import { Icon as PclnIcon } from 'pcln-icons';
export const Icon = PclnIcon;
Icon.isIcon = true;